import { Injectable } from '@angular/core';
import { CustomHttp } from '../shared/custom.http';

import 'rxjs/add/operator/toPromise';

import { DPUser } from './dp-user';
import { Router } from '@angular/router';
import { ApiConstants } from '../shared/api.constants';


@Injectable()
export class DPUserService {
    constructor(private router: Router, private http: CustomHttp, private apiConstants: ApiConstants) {
    }

    getRoles() {
        return this.http.get(this.apiConstants.ENDPOINT_HELPDESK_ROLE, { body: '' });
    }

    sendUserWelcomeEmail(user_id: number) {
        return this.http.get(this.apiConstants.getUserWelcomeEmailUrl(user_id), { body: '' });
    }

    getUsers(account_id: number) {
        const url = !account_id ? this.apiConstants.ALL_USERS_URL : `${this.apiConstants.ALL_USERS_URL}?accountId=${account_id}`;
        return this.http.get(url, { body: '' });
    }

    getUser(user_id: number) {
        return this.http.get(this.apiConstants.getUserByIdUrl(user_id), { body: '' });
    }

    getOwnUser() {
        return this.http.get(this.apiConstants.getUser(), { body: '' });
    }

    delete(user: DPUser) {
        return this.http.delete(this.apiConstants.getUserByIdUrl(user.user_id), { body: '' });
    }

    createUser(user: DPUser): Promise<DPUser> {
        return this.http.post(this.apiConstants.ENDPOINT_HELPDESK_USER, JSON.stringify(user));
    }

    updateUser(user: DPUser) {
        return this.http.put(this.apiConstants.getUserByIdUrl(user.user_id), JSON.stringify(user));
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-user.service.ts